// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p194 глобальна форма чіпів — поле пошуку за всіма селекторами, копіювання чіпа в інший стіл)
// Переносимый текст чипса стола: клик по чипсу полосы (или Copy / Ctrl+C) кладёт в буфер строку `webscm-chip:{json}` — селектор (binding поля, подпись,
// условие, сегмент значений, виджет-селектор) и выбранные значения { value, valueStr }. Вставка этой строки в поле поиска полосы ДРУГОГО стола включает
// там строку WHERE с тем же binding (AttrChips.barPaste). Чистые функции, без store: юнит tests/unit/chipsBarCopy.test.mjs.
// Флаги fe.ux.chipsBarCopy (формат при копировании и вставка) и fe.ux.chipsBarCopyOnClick (копирование кликом по чипсу) — дефолт вкл.
export const CHIP_PORTABLE_PREFIX = 'webscm-chip:'

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
const str = (x) => (x === undefined || x === null ? '' : String(x))
const hasVal = (v) => isObj(v) && v.value !== undefined && v.value !== null && v.value !== ''

// флаг (нет читателя / ошибка — дефолт dflt, по умолчанию ВКЛ)
// IE 2026 11 02 / ODOO-350449 (ревью webscm #125265 по p194: p200 — перенос періоду повністю, копіювання чіпа лише на десктопі і з підказкою): дефолт задаётся (fe.ux.chipsBarCopyOnClick — вкл на десктопе, выкл на телефоне)
export function chipsBarFlag_on(setting, key, dflt = true) {
    const d = dflt !== false
    try {
        if (typeof setting !== 'function') return d
        const v = setting(key, d)
        return v === undefined || v === null ? d : v !== false
    } catch (e) { return d }
}

// IE 2026 11 02 / ODOO-350449 (ревью webscm #125265 по p194: p200 — перенос періоду повністю, копіювання чіпа лише на десктопі і з підказкою)
// строка периода стола (mainStore.periodSel_row: condition 'between', значение «с» — rightValue.value, «по» — rightValue.valueTo) → { from, to } либо null.
// Раньше переносимый чипс брал из rightValue только value (дату «с»), valueTo терялся, а вставка шла путём списка значений (attrs) — период ломался
export function chipRow_period(row) {
    if (!isObj(row) || str(row.condition).trim().toLowerCase() !== 'between') return null
    const rv = isObj(row.rightValue) ? row.rightValue : {}
    const from = str(rv.value).trim(), to = str(rv.valueTo).trim()
    return from || to ? { from, to } : null
}

// binding строки стола: selector_binding либо leftValue.value
export function chipRow_binding(row) {
    return isObj(row) ? str(row.selector_binding || (isObj(row.leftValue) ? row.leftValue.value : '')).trim() : ''
}

// значения строки { value, valueStr }: включённые attrs, затем rightValue (если в нём значение) — без повторов
export function chipRow_portableValues(row) {
    const out = [], seen = new Set()
    const push = (v) => {
        if (!hasVal(v)) return
        const k = str(v.value)
        if (seen.has(k)) return
        seen.add(k)
        const x = { value: v.value }
        if (str(v.valueStr) !== '') x.valueStr = str(v.valueStr)
        out.push(x)
    }
    if (!isObj(row)) return out
    for (const a of (Array.isArray(row.attrs) ? row.attrs : [])) if (isObj(a) && a.use !== false) push(a.rightValue)
    push(row.rightValue)
    return out
}

// объект переносимого чипса по строке WHERE стола либо null (нет binding / нет значений)
export function chipRow_portableObj(row) {
    const binding = chipRow_binding(row)
    const period = chipRow_period(row)   // IE 2026 11 02 / ODOO-350449 (ревью webscm #125265 по p194: p200 — перенос періоду повністю, копіювання чіпа лише на десктопі і з підказкою)
    if (binding && period) {
        const o = { v: 1, binding, title: str(row.title || (isObj(row.leftValue) && row.leftValue.valueStr) || binding), condition: 'between', relation_segment: '', period,
            values: period.from ? [{ value: period.from, valueStr: period.from }] : [] }
        if (row.widget) o.widget = str(row.widget)
        return o
    }
    const values = chipRow_portableValues(row)
    if (!binding || !values.length) return null
    let seg = isObj(row.rightValue) ? str(row.rightValue.relation_segment) : ''
    if (!seg) for (const a of (Array.isArray(row.attrs) ? row.attrs : [])) { const s = isObj(a) && isObj(a.rightValue) ? str(a.rightValue.relation_segment) : ''; if (s) { seg = s; break } }
    const o = { v: 1, binding, title: str((isObj(row.leftValue) && row.leftValue.valueStr) || row.title || binding), condition: str(row.condition), relation_segment: seg, values }
    if (row.widget) o.widget = str(row.widget)
    return o
}

// строка для буфера либо '' (строка не переносится)
export function chipRow_portable(row) {
    const o = chipRow_portableObj(row)
    return o ? CHIP_PORTABLE_PREFIX + JSON.stringify(o) : ''
}

// разбор текста буфера: нормализованный объект { binding, title, condition, relation_segment, widget, values[, period { from, to }] } либо null (обычный текст)
export function chipPortable_parse(text) {
    const s = str(text).trim()
    if (!s.startsWith(CHIP_PORTABLE_PREFIX)) return null
    let o
    try { o = JSON.parse(s.slice(CHIP_PORTABLE_PREFIX.length)) } catch (e) { return null }
    if (!isObj(o)) return null
    const binding = str(o.binding).trim()
    if (!binding) return null
    // IE 2026 11 02 / ODOO-350449 (ревью webscm #125265 по p194: p200 — перенос періоду повністю, копіювання чіпа лише на десктопі і з підказкою): период — обе границы (from / to), значения для него не обязательны
    const p = isObj(o.period) ? { from: str(o.period.from).trim(), to: str(o.period.to).trim() } : null
    const period = p && (p.from || p.to) ? p : null
    if (!period && !Array.isArray(o.values)) return null
    const values = []
    for (const v of (Array.isArray(o.values) ? o.values : [])) {
        const x = isObj(v) ? v : { value: v }
        if (!hasVal(x) || values.some(y => str(y.value) === str(x.value))) continue
        values.push(str(x.valueStr) !== '' ? { value: x.value, valueStr: str(x.valueStr) } : { value: x.value })
    }
    if (!values.length && !period) return null
    const out = { binding, title: str(o.title).trim() || binding, condition: str(o.condition).trim(), relation_segment: str(o.relation_segment).trim(), widget: str(o.widget).trim(), values }
    if (period) { out.period = period; out.condition = 'between' }
    return out
}

// строка WHERE стола для вставленного чипса (по binding) либо null
export function chipPortable_findRow(WHERE, chip) {
    if (!chip || !Array.isArray(WHERE)) return null
    return WHERE.find(r => isObj(r) && chipRow_binding(r) === chip.binding) || null
}
